<script lang="ts">
    export let selected: boolean;
    export let selectedColor: string;
</script>

<div class="w-5 {selected ? selectedColor : 'stroke-neutral-700 group-hover:stroke-primary'} transition-colors">
    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="17" viewBox="0 0 12 17" fill="none">
        <path
            d="M11.4841 16.5H0.51585C0.733722 13.0804 3.16841 10.5 6 10.5C8.83159 10.5 11.2663 13.0804 11.4841 16.5Z"
        />
        <path
            d="M9.5 4.5C9.5 6.76613 7.87926 8.5 6 8.5C4.12074 8.5 2.5 6.76613 2.5 4.5C2.5 2.23387 4.12074 0.5 6 0.5C7.87926 0.5 9.5 2.23387 9.5 4.5Z"
        />
    </svg>
</div>
